import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { ADS_ENABLED } from '../config/admob';

// Google's consent rules: players in regions that need consent must be able to change their choice at any time.
function PrivacyChoicesLink() {
  const [required, setRequired] = useState(false);

  useEffect(() => {
    import('@capacitor-community/admob')
      .then(({ AdMob }) => AdMob.requestConsentInfo())
      .then((info) => setRequired(info.privacyOptionsRequirementStatus === 'REQUIRED'))
      .catch((err) => console.warn('[AdPrivacyChoices]', err));
  }, []);

  const openChoices = () => {
    import('@capacitor-community/admob')
      .then(({ AdMob }) => AdMob.showPrivacyOptionsForm())
      .catch((err) => console.warn('[AdPrivacyChoices]', err));
  };

  if (!required) return null;
  return (
    <>
      <span style={{ color: '#555', margin: '0 8px' }}>·</span>
      <button type="button" onClick={openChoices} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', textDecoration: 'underline', fontSize: 'inherit' }}>
        Ad Privacy Choices
      </button>
    </>
  );
}

export default function AdPrivacyChoices() {
  return ADS_ENABLED && Capacitor.isNativePlatform() ? <PrivacyChoicesLink /> : null;
}
